
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hikes",
      function () {
        return require("private-next-pages/hikes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hikes"])
      });
    }
  